// extracted by mini-css-extract-plugin
module.exports = {"content":"e_VE","blockTitle":"e_WE","source":"e_XE"};